
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news-alerts/[slug]",
      function () {
        return require("private-next-pages/news-alerts/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news-alerts/[slug]"])
      });
    }
  